var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 676,
    height: 383,
    fill: "none",
    viewBox: "0 0 676 383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.623 147.192h-15.23c-.421 0-.762-.342-.762-.762 0-.421.341-.762.762-.762h15.23c.42 0 .761.341.761.762 0 .42-.34.762-.761.762zM645.623 125.856h-19.038c-.42 0-.762-.342-.762-.762 0-.421.342-.762.762-.762h19.038c.42 0 .761.341.761.762 0 .42-.341.762-.761.762zM647.907 128.903h-19.799c-.421 0-.762-.342-.762-.762 0-.421.341-.762.762-.762h19.799c.421 0 .762.341.762.762 0 .42-.341.762-.762.762zM645.623 131.949h-15.23c-.421 0-.762-.341-.762-.761 0-.421.341-.762.762-.762h15.23c.42 0 .761.341.761.762 0 .42-.34.761-.761.761zM648.669 153.285h-18.276c-.421 0-.762-.341-.762-.761 0-.421.341-.762.762-.762h18.276c.42 0 .761.341.761.762.001.42-.34.761-.761.761zM647.907 150.238h-19.799c-.421 0-.762-.341-.762-.761 0-.421.341-.762.762-.762h19.799c.421 0 .762.341.762.762 0 .42-.341.761-.762.761z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.714 158.618c-1.149 0-2.123-.86-2.265-2.002-1.143-9.145-6.66-12.574-13.644-16.915-1.419-.882-2.887-1.795-4.394-2.8-10.155-6.773-9.419-15.476-9.383-15.842.125-1.249 1.247-2.167 2.497-2.049 1.251.125 2.169 1.242 2.052 2.489-.022.251-.444 6.387 7.369 11.598 1.408.94 2.814 1.815 4.173 2.66l.097.061c7.702 4.787 14.354 8.921 15.767 20.231.076.605-.089 1.204-.464 1.686-.374.482-.914.789-1.52.865-.094.013-.19.018-.285.018zm-27.409-38.094c-.386 0-.722.294-.761.686-.032.328-.69 8.152 8.712 14.424 1.487.991 2.944 1.897 4.352 2.773 7.33 4.556 13.119 8.154 14.352 18.021.051.411.428.713.847.661.205-.025.384-.128.509-.288.125-.161.18-.361.155-.563-1.323-10.588-7.689-14.545-15.06-19.126l-.097-.061c-1.37-.852-2.786-1.733-4.214-2.686-3.54-2.362-5.968-5.203-7.216-8.445-.965-2.504-.842-4.354-.826-4.556.04-.424-.266-.796-.681-.837l-.072-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.287 158.618c-.095 0-.191-.006-.288-.018-.603-.075-1.143-.383-1.518-.865-.374-.482-.539-1.081-.463-1.686 1.413-11.31 8.064-15.444 15.767-20.231l.096-.061c1.36-.846 2.766-1.72 4.174-2.66 7.813-5.212 7.39-11.347 7.369-11.606-.117-1.24.801-2.356 2.048-2.481 1.255-.117 2.376.799 2.501 2.046.036.369.771 9.071-9.383 15.844-1.507 1.006-2.974 1.918-4.394 2.8-6.984 4.341-12.501 7.77-13.644 16.915-.142 1.142-1.116 2.003-2.265 2.003zm27.406-38.095c-.025 0-.049.002-.074.004-.411.041-.717.414-.678.829.026.303.512 7.304-8.041 13.009-1.428.953-2.844 1.834-4.214 2.686l-.097.061c-7.371 4.581-13.737 8.538-15.059 19.126-.026.202.029.402.154.563.125.16.305.262.507.287.034.005.065.007.096.007.382 0 .706-.287.754-.668 1.232-9.867 7.022-13.465 14.351-18.021 1.409-.876 2.866-1.781 4.353-2.773 9.402-6.272 8.745-14.095 8.712-14.425-.04-.391-.375-.685-.764-.685z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFEFEF",
    strokeOpacity: 0.8,
    strokeWidth: 10,
    d: "M219.835 282c5.435 10.226 4.013 31.77-45.15 36.137-49.163 4.366-57.065 25.22-35.744 35.949 24.455 11.606 50.919 31.695-28.846 19.197C30.331 360.786 7.463 373.221 6 381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M207.254 207.614l6.048-8.305 6.384 8.305-6.384 9.06-6.048-9.06z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M88.222 210.977l10.234 1.073-4.018 9.668-11.057-.986 4.841-9.755z",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M15.726 186.896l2.49-9.961 9.037 5.315-2.517 10.786-9.01-6.14z",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M529.853 83.326l7.001-1.106-.945 7.148-7.533 1.31 1.477-7.352z",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M454.348 50.849l.741-7.033 6.675 2.76-.68 7.6-6.736-3.327z",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M167.802 141.663l1.374-12.587 11.976 4.898-1.27 13.6-12.08-5.911z",
    opacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear)",
    d: "M369.975 99.458l4.999-6.946 5.278 6.946-5.278 7.578-4.999-7.578z",
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear)",
    d: "M501.008 243.104l3.333-4.495 3.518 4.495-3.518 4.904-3.333-4.904z",
    opacity: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M564.52 172.517l1.591-5.361 4.847 3.023-1.625 5.808-4.813-3.47z",
    opacity: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear)",
    d: "M482.168 161.085l3.333-4.495 3.518 4.495-3.518 4.903-3.333-4.903z",
    opacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear)",
    d: "M262.406 82.053l-1.114-6.401 6.564.964 1.309 6.89-6.759-1.453z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear)",
    d: "M354.561 17.511l3.749-5.312 3.958 5.312-3.958 5.795-3.749-5.795z",
    opacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear)",
    d: "M283.063 3.756l6.417-1.11-.967 6.547-6.906 1.306 1.456-6.743z",
    opacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.25,
    d: "M550.994 229.59l.126 7.728 7.747.125-6.646 3.973 3.764 6.756-6.772-3.756-3.982 6.631-.125-7.729-7.747-.125 6.646-3.973-3.765-6.756 6.772 3.756 3.982-6.63z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.9,
    d: "M534.691 135.49l.087 5.351 5.364.086-4.602 2.751 2.607 4.677-4.689-2.6-2.757 4.59-.086-5.351-5.364-.086 4.602-2.751-2.607-4.677 4.688 2.601 2.757-4.591z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.77,
    d: "M458.187 213.832l.982 3.431 3.468-.868-2.487 2.563 2.487 2.563-3.468-.867-.982 3.431-.981-3.431-3.469.867 2.488-2.563-2.488-2.563 3.469.868.981-3.431zM457.33 107.035l.981 3.431 3.469-.868-2.487 2.563 2.487 2.564-3.469-.868-.981 3.431-.981-3.431-3.469.868 2.487-2.564-2.487-2.563 3.469.868.981-3.431zM330.863 79.103l.087 5.351 5.363.087-4.601 2.75 2.606 4.677-4.688-2.6-2.757 4.59-.087-5.35-5.363-.087 4.601-2.75-2.606-4.677 4.688 2.6 2.757-4.59z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.6,
    d: "M426.499 1.09l1.472 5.146 5.203-1.301-3.731 3.844 3.731 3.845-5.203-1.301-1.472 5.146-1.472-5.146-5.203 1.301 3.731-3.845-3.731-3.844 5.203 1.3 1.472-5.145z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.77,
    d: "M140.882 184.96l3.854 3.722 3.854-3.722-1.304 5.191 5.158 1.468-5.158 1.469 1.304 5.19-3.854-3.722-3.854 3.722 1.304-5.19-5.158-1.469 5.158-1.468-1.304-5.191z",
    opacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear)",
    d: "M7.708 229.211l1.472 5.146 5.203-1.301-3.731 3.844 3.731 3.845-5.203-1.301-1.472 5.146-1.472-5.146-5.203 1.301 3.73-3.845-3.73-3.844 5.203 1.301 1.472-5.146z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear)",
    d: "M404.537 125.201l-6.697 9.721-7.068-9.721 7.068-10.604 6.697 10.604z",
    opacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear)",
    d: "M536.325 121.265l-11.33-1.256 4.448-11.316 12.242 1.154-5.36 11.418z",
    opacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear)",
    d: "M616.589 149.448l-2.756 11.658-10.006-6.22 2.787-12.624 9.975 7.186z",
    opacity: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear)",
    d: "M47.371 270.672l-7.75 1.294 1.045-8.365 8.34-1.534-1.635 8.605z",
    opacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear)",
    d: "M130.965 308.686l-.82 8.231-7.391-3.231.754-8.894 7.457 3.894z",
    opacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear)",
    d: "M448.217 202.395l-1.522 14.733-13.259-5.733 1.407-15.917 13.374 6.917z",
    opacity: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear)",
    d: "M224.38 251.791l-5.536 8.131-5.842-8.131 5.842-8.869 5.536 8.869z",
    opacity: 0.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear)",
    d: "M79.306 83.661l-3.69 5.26-3.896-5.26 3.895-5.74 3.69 5.74z",
    opacity: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M8.989 166.279l-1.762 6.275-5.366-3.539 1.799-6.798 5.329 4.062z",
    opacity: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear)",
    d: "M100.166 179.661l-3.69 5.261-3.895-5.261 3.895-5.739 3.69 5.739z",
    opacity: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear)",
    d: "M343.476 272.162l1.233 7.493-7.267-1.129-1.449-8.064 7.483 1.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear)",
    d: "M241.447 347.704l-4.151 6.218-4.382-6.218 4.382-6.782 4.151 6.782z",
    opacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear)",
    d: "M320.605 363.803l-7.105 1.3 1.07-7.664 7.647-1.528-1.612 7.892z",
    opacity: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.25,
    d: "M23.964 99.48l-.14-9.047-8.576-.146 7.358-4.65-4.168-7.907 7.498 4.396 4.409-7.761.139 9.046 8.577.146-7.359 4.65 4.168 7.908-7.497-4.397-4.41 7.761z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.9,
    d: "M42.013 209.616l-.096-6.263-5.938-.101 5.094-3.219-2.886-5.474 5.191 3.043 3.053-5.373.096 6.263 5.938.101-5.095 3.219 2.886 5.475-5.19-3.044-3.053 5.373z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.77,
    d: "M126.716 117.922l-1.087-4.015-3.84 1.015 2.754-3-2.754-3 3.84 1.015 1.087-4.015 1.086 4.015 3.841-1.015-2.754 3 2.754 3-3.841-1.015-1.086 4.015zM127.664 242.922l-1.087-4.015-3.84 1.015 2.754-3-2.754-3 3.84 1.015 1.087-4.015 1.086 4.015 3.841-1.015-2.754 3 2.754 3-3.841-1.015-1.086 4.015zM267.684 275.616l-.096-6.263-5.938-.101 5.094-3.219-2.886-5.474 5.191 3.043 3.052-5.373.096 6.263 5.938.101-5.094 3.219 2.886 5.475-5.191-3.044-3.052 5.373z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.6,
    d: "M161.799 366.922l-1.63-6.023-5.761 1.523 4.131-4.5-4.131-4.5 5.761 1.523 1.63-6.023 1.63 6.023 5.76-1.523-4.131 4.5 4.131 4.5-5.76-1.523-1.63 6.023z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3F5",
    fillOpacity: 0.77,
    d: "M478.023 151.719l-4.267-4.357-4.267 4.357 1.444-6.076-5.711-1.718 5.711-1.719-1.444-6.076 4.267 4.357 4.267-4.357-1.444 6.076 5.711 1.719-5.711 1.718 1.444 6.076z",
    opacity: 0.6
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear)",
    d: "M625.466 99.922l-1.63-6.023-5.76 1.523 4.131-4.5-4.131-4.5 5.76 1.523 1.63-6.023 1.63 6.023 5.761-1.523-4.131 4.5 4.131 4.5-5.761-1.523-1.63 6.023z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#949599",
    d: "M444.827 240.6c0 10.933-2.466 20.6-7.4 29-4.8 8.267-11.333 14.733-19.6 19.4-8.133 4.667-17.266 7-27.4 7-10.133 0-19.333-2.333-27.6-7-8.133-4.667-14.666-11.133-19.6-19.4-4.8-8.4-7.2-18.067-7.2-29s2.4-20.533 7.2-28.8c4.934-8.4 11.467-14.933 19.6-19.6 8.267-4.8 17.467-7.2 27.6-7.2 10.134 0 19.267 2.4 27.4 7.2 8.267 4.667 14.8 11.2 19.6 19.6 4.934 8.267 7.4 17.867 7.4 28.8zm-24 0c0-6.8-1.4-12.667-4.2-17.6-2.666-5.067-6.333-9-11-11.8-4.533-2.8-9.6-4.2-15.2-4.2s-10.733 1.4-15.4 4.2c-4.533 2.8-8.2 6.733-11 11.8-2.666 4.933-4 10.8-4 17.6 0 6.667 1.334 12.533 4 17.6 2.8 4.933 6.467 8.8 11 11.6 4.667 2.8 9.8 4.2 15.4 4.2s10.667-1.4 15.2-4.2c4.667-2.8 8.334-6.667 11-11.6 2.8-5.067 4.2-10.933 4.2-17.6zM520.279 185c9.333 0 17.667 2.4 25 7.2 7.467 4.667 13.333 11.133 17.6 19.4 4.4 8.267 6.6 17.867 6.6 28.8s-2.2 20.6-6.6 29c-4.267 8.267-10.067 14.8-17.4 19.6-7.2 4.667-15.333 7-24.4 7-5.333 0-10.333-.867-15-2.6s-8.8-3.933-12.4-6.6c-3.467-2.667-6.2-5.333-8.2-8-1.867-2.8-2.8-5.133-2.8-7l6.2-2.6v52.6c0 3.467-1.133 6.333-3.4 8.6-2.267 2.4-5.133 3.6-8.6 3.6-3.467 0-6.333-1.133-8.6-3.4-2.267-2.267-3.4-5.2-3.4-8.8V199.2c0-3.467 1.133-6.333 3.4-8.6 2.267-2.4 5.133-3.6 8.6-3.6 3.467 0 6.333 1.2 8.6 3.6 2.267 2.267 3.4 5.133 3.4 8.6v9.8l-3.4-1.8c0-1.733.933-3.8 2.8-6.2 1.867-2.533 4.4-5 7.6-7.4 3.2-2.533 6.867-4.6 11-6.2 4.267-1.6 8.733-2.4 13.4-2.4zm-3 22c-5.867 0-11 1.467-15.4 4.4-4.4 2.933-7.867 6.933-10.4 12-2.4 4.933-3.6 10.6-3.6 17 0 6.267 1.2 12 3.6 17.2 2.533 5.067 6 9.067 10.4 12s9.533 4.4 15.4 4.4c5.867 0 10.933-1.467 15.2-4.4 4.4-2.933 7.8-6.933 10.2-12 2.533-5.2 3.8-10.933 3.8-17.2 0-6.4-1.267-12.067-3.8-17-2.4-5.067-5.8-9.067-10.2-12-4.267-2.933-9.333-4.4-15.2-4.4zM583.288 277.4c-1.333-1.867-1.933-4.267-1.8-7.2.134-2.933 1.867-5.467 5.2-7.6 2.134-1.333 4.4-1.867 6.8-1.6 2.4.133 4.734 1.333 7 3.6 3.867 3.867 7.934 6.867 12.2 9 4.267 2.133 9.6 3.2 16 3.2 2-.133 4.2-.4 6.6-.8 2.4-.533 4.467-1.6 6.2-3.2 1.867-1.733 2.8-4.333 2.8-7.8 0-2.933-1-5.267-3-7-2-1.733-4.666-3.2-8-4.4-3.2-1.2-6.8-2.333-10.8-3.4-4.133-1.2-8.4-2.533-12.8-4-4.266-1.467-8.2-3.333-11.8-5.6-3.6-2.4-6.533-5.533-8.8-9.4-2.266-3.867-3.4-8.733-3.4-14.6 0-6.667 1.867-12.333 5.6-17 3.734-4.667 8.534-8.267 14.4-10.8 6-2.533 12.267-3.8 18.8-3.8 4.134 0 8.467.533 13 1.6 4.534.933 8.867 2.533 13 4.8 4.134 2.133 7.6 5 10.4 8.6 1.467 2 2.334 4.4 2.6 7.2.267 2.8-1 5.333-3.8 7.6-2 1.6-4.333 2.333-7 2.2-2.666-.267-4.866-1.2-6.6-2.8-2.266-2.933-5.333-5.267-9.2-7-3.733-1.733-8.066-2.6-13-2.6-2 0-4.2.267-6.6.8-2.266.4-4.266 1.4-6 3-1.733 1.467-2.6 3.867-2.6 7.2 0 3.067 1 5.533 3 7.4 2 1.733 4.667 3.2 8 4.4 3.467 1.067 7.134 2.133 11 3.2 4 1.067 8.067 2.333 12.2 3.8 4.134 1.467 7.934 3.4 11.4 5.8 3.467 2.4 6.267 5.533 8.4 9.4 2.134 3.733 3.2 8.533 3.2 14.4 0 6.8-2 12.6-6 17.4-4 4.8-9 8.467-15 11-6 2.4-12.133 3.6-18.4 3.6-7.866 0-15.733-1.333-23.6-4-7.866-2.8-14.4-7.667-19.6-14.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#949599",
    d: "M351.999 223.5c0 46.116-37.384 83.5-83.499 83.5-46.116 0-83.5-37.384-83.5-83.5s37.384-83.5 83.5-83.5c46.115 0 83.499 37.384 83.499 83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A9A9",
    d: "M351.536 222.343c0 45.478-35.831 82.344-80.03 82.344-44.2 0-80.03-36.866-80.03-82.344 0-45.477 35.83-82.343 80.03-82.343 44.199 0 80.03 36.866 80.03 82.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3D2D2",
    d: "M352 223.27c0 44.966-34.277 81.418-76.56 81.418-42.284 0-76.561-36.452-76.561-81.418 0-44.966 34.277-81.418 76.561-81.418 42.283 0 76.56 36.452 76.56 81.418z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.549,
    cy: 221.188,
    r: 19.661,
    fill: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 222.743,
    cy: 254.89,
    r: 15.96,
    fill: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.507,
    cy: 154.803,
    r: 5.089,
    fill: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 288.392,
    cy: 271.608,
    r: 9.483,
    fill: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.894,
    cy: 189.73,
    r: 11.796,
    fill: "#E7E7E7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 200.66,
    x2: 220.44,
    y1: 222.069,
    y2: 215.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 72.377,
    x2: 87.738,
    y1: 212.508,
    y2: 226.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.04,
    x2: 30.978,
    y1: 202.762,
    y2: 189.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 519.584,
    x2: 532.304,
    y1: 87.163,
    y2: 93.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 455.404,
    x2: 464.997,
    y1: 61.737,
    y2: 51.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 169.632,
    x2: 186.842,
    y1: 161.14,
    y2: 142.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 364.524,
    x2: 380.911,
    y1: 111.549,
    y2: 106.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 497.374,
    x2: 508.237,
    y1: 250.927,
    y2: 247.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 478.534,
    x2: 489.397,
    y1: 168.908,
    y2: 165.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 262.365,
    x2: 288.369,
    y1: 75.558,
    y2: 90.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 350.473,
    x2: 362.806,
    y1: 26.757,
    y2: 22.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 273.619,
    x2: 285.046,
    y1: 7.41,
    y2: 13.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5930E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#6177FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 9.151,
    x2: 16.672,
    y1: 230.167,
    y2: 271.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 396.366,
    x2: 382.185,
    y1: 133.658,
    y2: 80.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 525.295,
    x2: 564.753,
    y1: 118.03,
    y2: 81.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 612.017,
    x2: 578.934,
    y1: 160.517,
    y2: 117.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 39.485,
    x2: 59.432,
    y1: 270.593,
    y2: 238.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 128.853,
    x2: 102.346,
    y1: 316.699,
    y2: 290.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 444.375,
    x2: 397.101,
    y1: 216.746,
    y2: 170.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 217.626,
    x2: 205.643,
    y1: 258.865,
    y2: 214.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 74.803,
    x2: 67.248,
    y1: 88.238,
    y2: 59.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 95.663,
    x2: 88.108,
    y1: 184.238,
    y2: 155.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 343.521,
    x2: 313.932,
    y1: 279.765,
    y2: 263.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 236.381,
    x2: 227.064,
    y1: 353.114,
    y2: 319.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 313.396,
    x2: 331.661,
    y1: 363.85,
    y2: 334.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 623.868,
    x2: 614.597,
    y1: 98.803,
    y2: 50.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A37E8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    width: 349.861,
    height: 169,
    x: 326.027,
    y: 175,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.643137 0 0 0 0 0.686275 0 0 0 0 0.756863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    width: 187,
    height: 187,
    x: 175,
    y: 134,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    width: 65.321,
    height: 65.321,
    x: 290.889,
    y: 188.527,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.643137 0 0 0 0 0.686275 0 0 0 0 0.756863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    width: 57.919,
    height: 57.92,
    x: 193.783,
    y: 225.93,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.643137 0 0 0 0 0.686275 0 0 0 0 0.756863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    width: 36.177,
    height: 36.177,
    x: 253.418,
    y: 136.715,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.643137 0 0 0 0 0.686275 0 0 0 0 0.756863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    width: 44.967,
    height: 44.967,
    x: 265.908,
    y: 249.125,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.643137 0 0 0 0 0.686275 0 0 0 0 0.756863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    width: 49.593,
    height: 49.593,
    x: 214.098,
    y: 164.934,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.643137 0 0 0 0 0.686275 0 0 0 0 0.756863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.6faf4b476ea3de7ce494bbf49f75b21a.svg";
export { ForwardRef as ReactComponent };